import { c as _c } from "react/compiler-runtime";
import { ProjectsOverview } from "@pages/projects/projects-overview";
import { AuthenticatedRoute } from "@router/authenticated-route";
/**
 * @returns The authenticated projects overview
 */
export function AuthenticatedProjectsOverview(t0) {
  const $ = _c(7);
  const {
    companyId,
    projectArchivingState,
    shouldForceLoading
  } = t0;
  const t1 = `${projectArchivingState}-projects`;
  let t2;
  if ($[0] !== companyId || $[1] !== projectArchivingState || $[2] !== shouldForceLoading) {
    t2 = <ProjectsOverview companyId={companyId} projectArchivingState={projectArchivingState} shouldForceLoading={shouldForceLoading} />;
    $[0] = companyId;
    $[1] = projectArchivingState;
    $[2] = shouldForceLoading;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <AuthenticatedRoute key={t1}>{t2}</AuthenticatedRoute>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}